const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const USER_ID = 'uid';
const ACCOUNT_ID = 'account';
const INITIALS = 'initials';
const NAME = 'name';
const FNAME = 'firstName';
const FULLMENU = 'fullmenu';
const PROJECT = 'project';
const GLOBAL_MESSAGE = 'global_message';
const SHOW_TABLE_FILTERS = 'show_table_filters';
const TABLE_SORTING = 'table_sorting';
const TABLE_HEADING_VISIBILITY = 'table_heading_visibility';
const HIDES = 'hide_items';
const DASHBOARD_VIEW = 'dashboard_view';
const SHARED_ACCOUNT = 'shared_account';

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {

    getFullMenu (){
        if ( localStorage.getItem(FULLMENU) !== null ) return localStorage.getItem(FULLMENU);
        return true;
    },

    getDashboardView (){
        if ( localStorage.getItem(DASHBOARD_VIEW) !== null ) return localStorage.getItem(DASHBOARD_VIEW);
        return 'tiles';
    },

    getCheckLogin() {
        return sessionStorage.getItem('checkedLogin');
    },

    getProject() {
        return sessionStorage.getItem(PROJECT);
    },

    getExtraInfo() {
        return JSON.parse(localStorage.getItem('extraInfo'));
    },

    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    getShowTableFilters() {
        let r = localStorage.getItem(SHOW_TABLE_FILTERS), 
            defaultFilters = { 'data-dive--keyword' : true, 'data-dive--url' : true, 'data-dive--url-overlay': true };
        if ( r ) {
            r = JSON.parse( r );
            return ( typeof r !== 'object' || typeof r.val !== 'object' ) ? defaultFilters : r.val;
        }
        return defaultFilters;
    },

    getTableSorting() {
        let r = localStorage.getItem(TABLE_SORTING);
        if ( r ) {
            return JSON.parse( r ).val;
        }
        return {};
    },
    
    getTableHeadingVisibility() {
        let r = localStorage.getItem(TABLE_HEADING_VISIBILITY);
        if ( r ) {
            return JSON.parse( r ).val;
        }
        return {};
    },

    getId() {
        return localStorage.getItem(USER_ID)
    },

    getAccountId() {
        return localStorage.getItem(ACCOUNT_ID)
    },

    getInitials() {
        return localStorage.getItem(INITIALS)
    },

    getName() {
        return localStorage.getItem(NAME)
    },

    getFirstName() {
        return localStorage.getItem(FNAME)
    },

    getSharedAccount() {
        let s = localStorage.getItem(SHARED_ACCOUNT);
        return ( !s || s === 'null' ) ? 'me' : s;
    },

    getHide(key) {
        let r = localStorage.getItem(HIDES);
        if ( r ) {
            r = JSON.parse( r );
            return !!key ? !!r[key] : r;
        }
        return !!key ? false : {};
    },

    getGlobalMessage() {
        let gm = sessionStorage.getItem(GLOBAL_MESSAGE);
        if ( gm ) {
            return JSON.parse( gm );
        }
        return { message: '', colour: 'red' };
    },

    saveId(id) {
        localStorage.setItem(USER_ID, id)
    },

    saveGlobalMessage(info) {
        sessionStorage.setItem(GLOBAL_MESSAGE, JSON.stringify(info))
    },

    saveCheckLogin() {
        sessionStorage.setItem('checkedLogin',true);
    },

    saveExtraInfo(info) {
        localStorage.setItem('extraInfo',JSON.stringify(info));
    },

    saveDashboardView(info) {
        localStorage.setItem(DASHBOARD_VIEW,info);
    },

    saveSharedAccount(info) {
        localStorage.setItem(SHARED_ACCOUNT,info);
    },

    saveShowTableFilters(info) {
        localStorage.setItem(SHOW_TABLE_FILTERS,JSON.stringify({val:info}));
    },

    saveHide(key,val) {
        let r = TokenService.getHide();
        r[key] = val;
        localStorage.setItem(HIDES,JSON.stringify(r));
    },

    saveTableSorting(info) {
        localStorage.setItem(TABLE_SORTING,JSON.stringify({val:info}));
    },

    saveTableHeadingVisibility(info) {
        localStorage.setItem(TABLE_HEADING_VISIBILITY,JSON.stringify({val:info}));
    },

    saveAccountId(id) {
        localStorage.setItem(ACCOUNT_ID, id)
    },

    saveInitials(init) {
        localStorage.setItem(INITIALS, init)
    },

    saveName(init) {
        localStorage.setItem(NAME, init)
    },

    saveFirstName(init) {
        localStorage.setItem(FNAME, init)
    },

    saveProject(projectId) {
        projectId === null ? projectId : projectId.toString();
        sessionStorage.setItem(PROJECT, projectId);
    },

    saveToken(accessToken) {

        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    saveFullMenu(showFullMenu) {
        localStorage.setItem(FULLMENU, showFullMenu);
    },

    removeToken() {
        
        localStorage.removeItem(TOKEN_KEY)
    },

    removeInitials() {
        localStorage.removeItem(INITIALS)
    },

    removeGlobalMessage() {
        sessionStorage.removeItem(GLOBAL_MESSAGE)
    },

    removeName() {
        localStorage.removeItem(NAME)
    },

    removeSharedAccount() {
        localStorage.removeItem(SHARED_ACCOUNT)
    },

    removeFirstName() {
        localStorage.removeItem(FNAME)
    },

    removeProject() {
        sessionStorage.removeItem(PROJECT)
    },

    removeCheckLogin() {
        sessionStorage.removeItem('checkedLogin');
    },

    removeExtraInfo() {
        localStorage.removeItem('extraInfo');
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    },

    removeId(id) {
        localStorage.removeItem(USER_ID)
    },

    removeAccountId(id) {
        localStorage.removeItem(ACCOUNT_ID)
    }

}

export { TokenService }